import React from "react";
import { Sparkles, Calendar, MessageSquareOff, Zap } from "lucide-react";

const NICHES = [
  "Studios",
  "Schools",
  "Coaches",
  "Churches",
  "Programs",
];

const STATS = [
  { icon: Calendar, label: "more bookings", value: "+3.4×" },
  { icon: MessageSquareOff, label: "less back-and-forth", value: "−68%" },
  { icon: Zap, label: "fast-track launch", value: "24 hrs" },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="border-y border-nav-800 bg-nav-900/40 py-7"
    >
      <div className="container-x">
        <div className="grid lg:grid-cols-[1fr,auto,1fr] gap-6 lg:gap-10 items-center">
          {/* Niche callout */}
          <div className="flex flex-wrap items-center gap-x-3 gap-y-2 lg:justify-start justify-center">
            <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.22em] text-brand">
              <Sparkles className="h-3 w-3" />
              Built for
            </span>
            <span className="text-sm text-nav-200 font-medium">
              {NICHES.map((n, i) => (
                <React.Fragment key={n}>
                  <span className="text-white">{n}</span>
                  {i < NICHES.length - 1 && (
                    <span className="text-nav-500 mx-1.5">·</span>
                  )}
                </React.Fragment>
              ))}
            </span>
          </div>

          {/* Divider */}
          <div className="hidden lg:block h-10 w-px bg-nav-800" aria-hidden="true" />

          {/* Outcome stats */}
          <div className="grid grid-cols-3 gap-3 sm:gap-6">
            {STATS.map(({ icon: Icon, label, value }) => (
              <div
                key={label}
                className="flex items-center gap-2 sm:gap-3 justify-center lg:justify-start"
              >
                <Icon className="h-4 w-4 text-brand shrink-0" />
                <div>
                  <div className="font-display text-base sm:text-lg font-bold text-white leading-none">
                    {value}
                  </div>
                  <div className="text-[10px] sm:text-[11px] text-nav-400 mt-0.5">
                    {label}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
